import { combineReducers } from "redux";

// Front
import layoutReducer from "../app/layouts/store/reducer";

// Authentication
import authReducer from "../features/Authentication/store/login/reducer";
import profileReducer from "../features/Authentication/store/profile/reducer";
import { configureStore } from "@reduxjs/toolkit";

export const rootReducer = combineReducers({
  layout: layoutReducer,
  auth: authReducer,
  profile: profileReducer,
});

export const store = configureStore({ reducer: rootReducer, devTools: true });

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
